Pixlee.module('CarouselApp', function(CarouselApp, App, Backbone, Marionette, $) {
    CarouselApp.on('start', function(options) {
        new CarouselApp.Controller(options);
    });
});